import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Testimonials from './components/Testimonials';
import Experience from './components/Experience';
import Portfolio from './components/Portfolio';
import Footer from './components/Footer';
import data from './data';
import { DNA } from 'react-loader-spinner';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-full min-h-screen bg-[#fffcf7] font-sans text-active selection:bg-crimson selection:text-white">

      {loading && (
        <div className="fixed inset-0 bg-white z-[9999] flex items-center justify-center">
          <DNA
            visible={true}
            height={100}
            width={100}
            ariaLabel="dna-loading"
          />
        </div>
      )}

      {!loading && (
        <div className="flex flex-col items-center overflow-x-hidden">
          <Header />
          <Hero />

          <Testimonials />

          <Experience />

          <section id="portfolio" className="w-full max-w-7xl px-8 py-24">
            <div className="text-center mb-20 space-y-4">
              <h2 className="text-5xl font-bold text-active inline-block relative">
                Featured Projects
                <span className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-20 h-1 bg-crimson rounded-full"></span>
              </h2>
            </div>

            <div className="flex flex-col gap-10">
              {data.map((item, index) => (
                <Portfolio key={item.id} item={item} index={index} />
              ))}
            </div>
          </section>

          <Footer />
        </div>
      )}
    </div>
  );
}

export default App;
